import { useMutation, useQueryClient } from "@tanstack/react-query";
import { authUserApplication } from "@/api/v1-jwt/tenancy/tenancy";
import { useAuth } from "@/providers/auth";

export function useAuthUserApplication() {
  const queryClient = useQueryClient();
  const { cognitoId } = useAuth();

  return useMutation({
    mutationFn: async (payload) => authUserApplication(cognitoId, payload),
    onSuccess: () => queryClient.invalidateQueries(["tenancy"]),
  });
}
